<template>
  <section class="layout-columns" :style="sectionStyle">
    <div
      class="layout-columns__grid"
      :style="gridStyle"
    >
      <div
        v-for="(cell, idx) in cells"
        :key="idx"
        class="layout-columns__cell"
      >
        <AppLayoutNestedContent :blocks="cell.blocks || []" />
      </div>
    </div>
  </section>
</template>

<script>
import AppLayoutNestedContent from '@/components/Blocks/AppLayoutNestedContent.vue'

export default {
  name: 'AppLayoutColumnsBlock',
  components: { AppLayoutNestedContent },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    columns() {
      const n = Number(this.data && this.data.columns) || 2
      return Math.min(3, Math.max(2, n))
    },
    gap() {
      return (this.data && this.data.gap) || '24px'
    },
    cells() {
      const list = (this.data && this.data.cells) || []
      if (list.length) return list
      return Array.from({ length: this.columns }, () => ({ width: 1, blocks: [] }))
    },
    gridStyle() {
      return {
        gap: this.gap,
        gridTemplateColumns: `repeat(${this.columns}, minmax(0, 1fr))`,
      }
    },
    sectionStyle() {
      return {}
    },
  },
}
</script>

<style scoped lang="scss">
.layout-columns {
  padding: 24px 0;

  &__grid {
    display: grid;
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 20px;
  }

  &__cell {
    min-width: 0;
  }

  @media (max-width: 768px) {
    &__grid {
      grid-template-columns: 1fr !important;
    }
  }
}
</style>
